'use client'

import { Tabs, TabsList, TabsTrigger } from '@mentora/ui-components'
import { useTranslations } from 'next-intl'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useTransition } from 'react'

interface Props {
  selectedWindow: '7' | '30' | '90'
}

/**
 * The dashboard's time window. Which organization it covers is the sidebar
 * selector's job (the session's active organization), not a URL filter.
 */
export function DashboardFilters({ selectedWindow }: Props) {
  const t = useTranslations('dashboard.filters')
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [, startTransition] = useTransition()

  function selectWindow(value: string) {
    const params = new URLSearchParams(searchParams.toString())
    params.set('window', value)
    startTransition(() => {
      router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    })
  }

  return (
    <Tabs value={selectedWindow} onValueChange={selectWindow}>
      <TabsList>
        <TabsTrigger value="7">{t('window7')}</TabsTrigger>
        <TabsTrigger value="30">{t('window30')}</TabsTrigger>
        <TabsTrigger value="90">{t('window90')}</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
